import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-search-network-label',
  templateUrl: './search-network-label.component.html',
  styleUrls: ['./search-network-label.component.scss']
})

export class SearchNetworkLabelComponent implements OnInit {

  @Input() networkTrigger: string;
  networkObj: NetworkObj;
  networkObjList: NetworkObjList;

  constructor() {
    this.networkObj = new NetworkObj(null, null, null, null, null, null);
    this.networkObjList = new NetworkObjList();
  }

  ngOnInit() {
    if (this.networkTrigger) {
      let objList: NetworkObj[];
      objList = this.networkObjList.networkObjs.filter(obj => obj.networkTrigger === this.networkTrigger);
      if (objList.length > 0) {
        this.networkObj = objList[0];
      }
    }
  }

}

class NetworkObjList {

  constructor() {
    this.networkObjs = [];
    this.networkObjs.push(
      // new NetworkObj('TowerEmployee', 'Tower Health', true, true, 'https://cdn.upmchp.com/providerdirectory/assets/clientImages/TowerHealth/tower-health-hz.png', 'Tower Health Employee Search Logo')
      new NetworkObj('TowerEmployee', null, false, false, null, null, true)
    );
    this.networkObjs.push(
      new NetworkObj('TowerHealth', 'Tower Health', false, false, null, null)
    );
  }

  networkObjs: NetworkObj[];
}

class NetworkObj {

  constructor(networkTrigger, networkName, hasCSS, hasImg, imgUrl, imgTitle, hideLabel?) {
    this.networkTrigger = networkTrigger;
    this.networkName = networkName;
    this.hasCSS = hasCSS;
    this.hasImg = hasImg;
    this.imgUrl = imgUrl;
    this.imgTitle = imgTitle;
    this.hideLabel = hideLabel;
  }

  networkTrigger: string;
  networkName: string;
  hasCSS: boolean;
  hasImg: boolean;
  imgUrl: string;
  imgTitle: string;
  hideLabel?: boolean;
}
